import React from 'react';
import NumberInput, { NumberInputProps } from './number-input';
import './number-input-with-unit.css';

type NumberInputWithUnitProps = Omit<NumberInputProps, 'unit'> & { unit: string };

const NumberInputWithUnit = (props: NumberInputWithUnitProps) => {
    const { unit, validationOverride, ...numberInputProps } = props;

    return (
        <div className="number-input-with-unit">
            <NumberInput {...numberInputProps} unit={unit} validationOverride={validationOverride} />
            <span>{unit}</span>
        </div>
    );
}

export default NumberInputWithUnit;
